import { render, staticRenderFns } from "./Convenios.vue?vue&type=template&id=33714f1e&scoped=true&"
import script from "./Convenios.vue?vue&type=script&lang=ts&"
export * from "./Convenios.vue?vue&type=script&lang=ts&"
import style0 from "./Convenios.vue?vue&type=style&index=0&id=33714f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33714f1e",
  null
  
)

export default component.exports